<template>
  <div class="container-fluid">
    <div class="dash-head">
      <div class="row">
        <div
          class="col-8 d-flex justify-content-start align-items-center text-white"
          style="font-size: 28px; padding-top: 0px; line-height: 28px;"
        >
          <img
            src="/static/img/icons/android-chrome-192x192.png"
            alt="logo"
            style="height: 72px;"
          />&nbsp; RMUTL Open House
        </div>
        <div
          class="col-4 d-flex justify-content-end align-items-center text-white"
          style="font-size: 28px;"
        >
          <input type="date" v-model="dateNow" @change="getDashboard()">
        </div>
      </div>
    </div>
    <div class="container-fluid dash pt-2">
      <div class="row">
        <div class="mb-2 col-sm-6">
          <div class="card">
            <div
              class="card-header text-white bg-rmutl d-flex justify-content-center align-items-center"
              style="font-size: 40px;"
            >
              ผู้ลงทะเบียนทั้งหมด
            </div>
            <div class="card-body d-flex justify-content-center align-items-center flex-column">
              <p style="font-size: 108px; color: #555555; font-weight: 700;">
                {{ numberFormatold(result_data.user[0].total) }}
              </p>
              <div
                class="w-100 d-flex justify-content-end"
                style="font-size: 24px; color: #555555;"
              >
                คน
              </div>
            </div>
          </div>
        </div>
        <div class="mb-2 col-sm-6">
          <div class="card">
            <div
              class="card-header text-white bg-rmutl d-flex justify-content-center align-items-center"
              style="font-size: 40px;"
            >
              จำนวนเข้าร่วมกิจกรรมทั้งหมด
            </div>
            <div class="card-body d-flex justify-content-center align-items-center flex-column">
              <p style="font-size: 108px; color: #555555; font-weight: 700;">
                {{ numberFormatold(workshopTotal) }}
              </p>
              <div
                class="w-100 d-flex justify-content-end"
                style="font-size: 24px; color: #555555;"
              >
                ครั้ง
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div :class="{ 'col-sm-12': $store.state.screenWidth <= 1440, 'col-sm-12': $store.state.screenWidth > 1440 }">
          <div
            class="bg-rmutl text-white d-flex justify-content-center align-items-center"
            style="font-size: 40px; height: 90px;"
          >
            จำนวนเข้าร่วมกิจกรรมแบ่งตามคณะ
          </div>
          <div class="row p-2">
            <div
              class="col-sm p-1"
              v-for="(fac, i) in result_data.fac"
              :key="'fac' + i"
            >
              <div class="card">
                <div class="card-body d-flex justify-content-center align-items-between flex-column">
                  <div
                    class="fac_title"
                    :style="{ 'font-size': $store.state.screenWidth <= 1440 ? '16px': '18px' }"
                  >{{ fac.name }}</div>
                  <div
                    class="fac_count"
                    :style="{ color: fac.color }"
                  >{{ numberFormatold(fac.total) }}</div>
                  <div class="fac_footer">ครั้ง</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 p-5 d-flex justify-content-center align-items-center"
        v-if="result_data.workshop.length < 1"
      >
        <div
          class="spinner-border text-azure"
          role="status"
        ></div>
      </div>
      <div class="row">
        <div
          class="col-sm-3 mb-2"
          v-for="(ws, i) in sortWorkshop"
          :key="'wsc' + i"
        >
          <div
            class="card"
            style="min-height: 135px;"
          >
            <div
              class="ribbon"
              :style="{ 'background': ws.fac_color }"
            >
              <img
                :src="'/static/img/logo/' + ws.fac_id + '.png'"
                alt="bala"
                width="24"
              />
            </div>
            <div class="card-body row">
              <div class="col-3 d-flex justify-content-center align-items-center">
                <span
                  style="color: #555; font-weight: 700;"
                  :style="{ 'font-size': $store.state.screenWidth <= 1440 ? '50px': '60px' }"
                >{{ ws.total }}</span>
              </div>
              <div class="col-8 d-flex justify-content-center align-items-start flex-column">
                <b
                  class="text-body d-block"
                  :style="{ 'font-size': $store.state.screenWidth <= 1440 ? '14px': '18px' }"
                >{{ ws.workshop_name }}</b>
                <div
                  class="text-muted text-truncate mt-n1"
                  :style="{ 'font-size': $store.state.screenWidth <= 1440 ? '12px': '16px' }"
                >
                  {{ ws.fac_name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Swal from 'sweetalert2'
import api from '../assets/services'

export default {
  name: 'dash',
  data () {
    return {
      dateNow: moment(new Date()).format('YYYY-MM-DD'),
      isLoad: true,
      result_data: {
        user: [
          {
            name: 'ผู้เข้าร่วมทั้งหมด',
            total: 0
          }
        ],
        fac: [
          {
            id: '1',
            name: 'คณะบริหารธุรกิจและศิลปศาสตร์',
            color: '#1E90FF',
            total: '0'
          },
          {
            id: '2',
            name: 'คณะวิทยาศาสตร์และเทคโนโลยีการเกษตร',
            color: '#2F462B',
            total: '0'
          },
          {
            id: '3',
            name: 'คณะวิศวกรรมศาสตร์',
            color: '#710808',
            total: '0'
          },
          {
            id: '4',
            name: 'คณะศิลปกรรมและสถาปัตยกรรมศาสตร์',
            color: '#E65F32',
            total: '0'
          },
          {
            id: '5',
            name: 'วิทยาลัยเทคโนโลยีและสหวิทยาการ',
            color: '#33363B',
            total: '0'
          }
        ],
        workshop: []
      },
      setTime: ''
    }
  },
  computed: {
    sortWorkshop: function () {
      return this.result_data.workshop.sort((a, b) => b['total'] - a['total'])
    },
    workshopTotal: function () {
      let total = 0
      this.result_data.fac.forEach(v => {
        total += parseInt(v['total'])
      })
      return total
    }
  },
  methods: {
    async getDashboard () {
      clearInterval(this.setTime)
      api.dashboard(
        this.$store.state.URL,
        this.dateNow,
        {
          headers: {
            'Public-Token':
              'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiT3BlbiBIb3VzZSBSTVVUTCIsInR5cGUiOiJ3ZWJfYXBpIiwiY3JlYXRlIjoiMjAyMi0wOS0wOSAwOTowOTowOSJ9.s8p__DdvjrhZAJAN0Nc8CVV1TnaGHPvXR7NMg-OSl80'
          }
        },
        (result) => {
          if (result.status === 'SUCCESS') {
            this.result_data = result.data
            this.setTime = setInterval(async () => {
              await this.getDashboard()
            }, 10000)
          } else {
            Swal.fire({
              title: 'ดึงข้อมูล',
              text: 'ไม่สามารถดึงข้อมูล เนื่องจาก' + result.message,
              icon: 'error',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: 'ลองใหม่อีกครั้ง',
              denyButtonText: 'ยกเลิก'
            }).then(async (result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                await this.getDashboard()
              } else if (result.isDenied) {
                localStorage.clear()
                this.$router.push('/').catch(() => { })
              }
            })
          }
        },
        (error) => {
          Swal.fire({
            title: 'ดึงข้อมูล',
            text: 'ไม่สามารถดึงข้อมูล เนื่องจาก' + JSON.stringify(error),
            icon: 'error',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'ลองใหม่อีกครั้ง',
            denyButtonText: 'ยกเลิก'
          }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              await this.getDashboard()
            } else if (result.isDenied) {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            }
          })
        }
      )
    }
  },
  destroyed () {
    clearInterval(this.setTime)
  },
  async mounted () {
    await this.getDashboard()
  }
}
</script>

<style scoped>
.dash {
  background-color: #fafafa !important;
  height: 92vh;
  width: 100vw;
  position: absolute;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;
  overflow-x: hidden;
}

.dash-head {
  padding: 8px 20px;
  height: 5vh;
  width: 100vw;
  position: absolute;
  right: 0px;
  top: -10px;
}

.fac_title {
  color: #555555;
  width: 100%;
  text-align: left;
  height: 40px;
}

.fac_count {
  font-size: 80px;
  text-align: center;
  font-weight: 700;
}

.fac_footer {
  font-size: 16px;
  color: #555555;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue